module.exports = __webpack_public_path__ + "img/address-new.68b6c262.png";